// extracted by mini-css-extract-plugin
export default {"root":"_2TZrZ","traded":"_1nCzO","icon":"_11wuX","warning":"_20MdW"};